import { absoluteUrl, ogImageUrl, type RouteSeoDescriptor } from './site';

const JSON_LD_ID = 'examflow-json-ld';

function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertLink(rel: string, href: string) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

function upsertJsonLd(data: Record<string, unknown> | undefined) {
  const existing = document.getElementById(JSON_LD_ID);
  if (!data) {
    existing?.remove();
    return;
  }
  let el = existing as HTMLScriptElement | null;
  if (!el) {
    el = document.createElement('script');
    el.type = 'application/ld+json';
    el.id = JSON_LD_ID;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

/** Apply SEO descriptor to the live document head (CSR). */
export function applyDocumentHead(seo: RouteSeoDescriptor) {
  document.title = seo.title;
  upsertMeta('name', 'description', seo.description);
  upsertMeta('name', 'robots', seo.robots);
  upsertLink('canonical', absoluteUrl(seo.canonicalPath));

  upsertMeta('property', 'og:title', seo.title);
  upsertMeta('property', 'og:description', seo.description);
  upsertMeta('property', 'og:type', seo.ogType);
  upsertMeta('property', 'og:url', absoluteUrl(seo.canonicalPath));
  upsertMeta('property', 'og:image', ogImageUrl());
  upsertMeta('property', 'og:site_name', 'ExamFlow');
  upsertMeta('property', 'og:locale', 'zh_CN');

  upsertMeta('name', 'twitter:card', 'summary_large_image');
  upsertMeta('name', 'twitter:title', seo.title);
  upsertMeta('name', 'twitter:description', seo.description);
  upsertMeta('name', 'twitter:image', ogImageUrl());

  upsertJsonLd(seo.jsonLd);
}
